<template>
  <div v-tooltipable>{{ stripHTMLTagsFromString(message ?? "-", false) }}</div>
</template>
<script setup lang="ts">
import { stripHTMLTagsFromString } from "@/helpers/common";

const { message } = defineProps<{ message: string | null }>();
</script>
